import registerReduxModal from 'components/common/hoc/registerReduxModal'
import { CONTENT_MODAL } from 'constant'
import ContentModal from './ContentModal'

export default registerReduxModal({ name: CONTENT_MODAL })(ContentModal)
